import {useLingui} from '@lingui/react/macro'

import {WorkCardBadge} from '#/components/work'

/**
 * The one thing a classroom capsule's card says that no other capsule's does.
 *
 * A capsule made for a room is a post like any other — it can be commented on and
 * reacted to, which is the whole reason it is a post (see
 * `#/state/classrooms/types`) — so its card is the app's capsule card, drawn by
 * the same component the capsule feed draws (see `CapsulePostCard`), and the same
 * is true of a book and `FlashBookFeedEmbed`. The card cannot say the one thing
 * that is different about this work: it is not on the author's profile afterwards,
 * and it is in no feed. For a reader, that is the difference between "it is not
 * there" and "this is broken", so the card carries it as a badge.
 *
 * The pill itself is `WorkCardBadge`, shared with the badge a creator's own profile
 * puts on their unfinished work: two facts about work that are otherwise unrelated,
 * said in one corner in one voice. What is left here is the words.
 */
export function ClassroomOnlyBadge({
  belowKindChip = false,
}: {
  /**
   * Set for a card whose own top-left corner is already taken (a book's cover,
   * which prints "Storybook" or "Video" there). See `WorkCardBadge`.
   */
  belowKindChip?: boolean
}) {
  const {t: l} = useLingui()
  return (
    <WorkCardBadge label={l`Classroom only`} belowKindChip={belowKindChip} />
  )
}
